/**
 * Loading spinner component
 */

import {cn} from '../../utils/cn';

interface LoadingProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function Loading({size = 'md', className}: LoadingProps) {
  return (
    <div
      className={cn(
        'animate-spin rounded-full border-b-2 border-primary-600 dark:border-[#4A9EFF]',
        {
          'h-4 w-4': size === 'sm',
          'h-8 w-8': size === 'md',
          'h-12 w-12': size === 'lg',
        },
        className
      )}
    />
  );
}

